import { useId } from 'react'

/**
 * Choisir une image, sans montrer le champ du navigateur.
 *
 * Le champ de fichier natif s'affichait tel quel — « Sélect. fichiers · Aucun fichier choisi »,
 * dans la police et les couleurs du système — au milieu d'une feuille dessinée au pixel. C'était
 * la seule pièce de l'application qui n'appartenait pas à l'application.
 *
 * Le champ reste là, invisible mais bien présent : c'est l'étiquette qui l'actionne. Rien n'est
 * réécrit, donc le sélecteur du téléphone, l'appareil photo et l'accessibilité fonctionnent
 * exactement comme avant — seule l'apparence change.
 */
export function ChoixDImage({
  libelle,
  multiple = false,
  disabled = false,
  onChoix,
}: {
  libelle: string
  multiple?: boolean
  disabled?: boolean
  onChoix: (fichiers: readonly File[]) => void
}) {
  const identifiant = useId()

  return (
    <>
      <input
        id={identifiant}
        type="file"
        accept="image/*"
        multiple={multiple}
        disabled={disabled}
        onChange={(evenement) => {
          const choisis = Array.from(evenement.target.files ?? [])

          // Vidé aussitôt : sans cela, rechoisir le même fichier ne déclenche aucun événement,
          // et l'on croit que l'application n'a rien vu.
          evenement.target.value = ''

          if (choisis.length > 0) {
            onChoix(choisis)
          }
        }}
        className="sr-only"
      />

      <label
        htmlFor={identifiant}
        className="flex w-full items-center justify-center gap-2 rounded-button border border-border bg-card text-meta font-semibold"
        style={{
          height: 48,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <Appareil />
        {libelle}
      </label>
    </>
  )
}

/** Appareil photo au trait fin, comme les icônes d'outil. */
function Appareil() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      <path d="M3.5 8.5h3l1.5-2h8l1.5 2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1z" />
      <circle cx="12" cy="13" r="3.2" />
    </svg>
  )
}
